export default __webpack_public_path__ + "static/media/GNP-colorNew.50c5a9ec.svg";